export class UnitConversion {
  id : number;
  derivedFrom : string;
  unit : string;
  factorDerived : number;
}
